import { Button, Heading, VStack } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

interface ErrorFallbackProps {
  resetError: () => void
}

export const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  const { t } = useTranslation('common')

  return (
    <VStack
      alignItems="center"
      justifyContent="center"
      spacing="32px"
      height="100%"
      flex="1 1 100%"
    >
      <Heading fontSize="xl">{t('TRANSLATION_50')}</Heading>
      <Button variant="outline" onClick={() => resetError()}>
        {t('TRANSLATION_51')}
      </Button>
    </VStack>
  )
}
